// components/skeletons/SkeletonHeroSection.js
export default function SkeletonHeroSection() {
  return (
    <section className="hero-section section_short-padding">
      <div className="container">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 hero-content">
          {/* Left part */}
          <div className="left-part space-y-6">
            {/* Title */}
            <div className="w-3/4 h-12 bg-gray-300 rounded animate-pulse"></div>
            {/* Subtitle */}
            <div className="w-1/2 h-6 bg-gray-300 rounded animate-pulse"></div>
            {/* Features list */}
            <div className="flex space-x-6">
              {[1, 2, 3, 4].map((item) => (
                <div key={item} className="feature-item flex flex-col items-center space-y-2">
                  <div className="w-12 h-12 bg-gray-300 rounded-full animate-pulse"></div>
                  <div className="w-16 h-4 bg-gray-300 rounded animate-pulse"></div>
                </div>
              ))}
            </div>
            {/* Buttons */}
            <div className="flex space-x-4">
              <div className="w-32 h-10 bg-gray-300 rounded animate-pulse"></div>
              <div className="w-28 h-10 bg-gray-300 rounded animate-pulse"></div>
            </div>
          </div>

          {/* Right part */}
          <div className="right-part flex justify-center items-center">
            <div className="w-full max-w-md h-64 bg-gray-300 rounded animate-pulse relative">
              {/* Play button placeholder */}
              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-16 h-16 bg-gray-400 rounded-full animate-pulse"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
